import { ErrorResource } from "../locales";

export const error: ErrorResource = {
    couldNotSave: "Speichern fehlgeschlagen",
    ohNoSomethingWentWrong: "Oh nein! Etwas ist schiefgelaufen! :(",
    refreshAndTryAgain: "Bitte Seite neu laden und erneut versuchen.",
    goToLogin: "Zur Anmeldung",
};
